// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1rf2F","title":"ClientCherryInfo_title__2dqBB","itemText":"ClientCherryInfo_itemText__3iDHQ"};